<template>
  <div style="margin: 0 auto 5rem; max-width: 960px;">
    <HeaderBar
      view="save"
      :showBar="showHeaderBar"
      :showText="false"
      @save="saveMatchmakingRequest()"
      @discard="discardModalOpen = true"
    />
    <div class="dashboard-title mb-xs">
      <div>
        <BackButton
          link="/matchmaking-requests"
          text="Back to Matchmaking requests"
        />
        <h1 class="fw-bold fs-xl" style="margin-bottom: 1.7em;">
          {{ matchmakingDetail.companyName }}
        </h1>
      </div>
    </div>
    <div>
      <template v-if="loading">
        <Logo></Logo>
      </template>
      <template v-else>
        <Card style="max-width: 600px;">
          <div class="grid grid--middle">
            <div
              class="grid__cell col6-of-12--medium-up"
              style="margin-bottom: 0;"
            >
              <Select
                :disabled="isDisabled"
                label="Assign to"
                placeholder="Select a partner"
                :options="partners"
                :selected="selectedPartner"
                :showSearchSelect="true"
                @input-change="updatePartner($event)"
                :key="saveKey"
              ></Select>
            </div>
            <div
              class="grid__cell col6-of-12--medium-up"
              style="margin-bottom: 0;"
            >
              <Select
                label="Status"
                :options="[
                  {
                    name: 'New',
                    value: 'N',
                  },
                  {
                    name: 'Pending',
                    value: 'P',
                  },
                  {
                    name: 'Done',
                    value: 'D',
                  },
                ]"
                :selected="selectedStatusValue"
                @input-change="updateStatus($event)"
                :required="true"
              ></Select>
            </div>
          </div>
        </Card>
        <SectionHeading
          heading="Customer details"
          description="Information submitted about the customer who needs help or is a good candidate for a partner to assist"
        />
        <Card>
          <div class="grid">
            <div class="grid__cell col12-of-12--large-up">
              <div class="grid">
                <div>
                  <div class="grid__cell col4-of-12--large-up mb-sm">
                    <p class="theme-text-dark fw-semibold fs-sm mb-xs">
                      Request date:
                    </p>
                    <p class="fs-sm theme-text-medium">
                      {{ showDate(matchmakingDetail.created) }}
                    </p>
                  </div>
                  <div class="grid__cell col4-of-12--large-up mb-sm">
                    <p
                      class="f-capitalize theme-text-dark fw-semibold fs-sm mb-xs"
                    >
                      customer:
                    </p>
                    <p class="fs-sm theme-text-medium">
                      {{ matchmakingDetail.companyName }}
                    </p>
                  </div>
                  <div class="grid__cell col4-of-12--large-up mb-sm">
                    <p
                      class="f-capitalize theme-text-dark fw-semibold fs-sm mb-xs"
                    >
                      Contact person:
                    </p>
                    <p class="fs-sm theme-text-medium">
                      {{ name }}
                    </p>
                  </div>

                  <div class="grid__cell col4-of-12--large-up mb-sm">
                    <p class="theme-text-dark fw-semibold fs-sm mb-xs">
                      Contact email address:
                    </p>
                    <p class="fs-sm theme-text-medium">
                      {{ matchmakingDetail.email }}
                    </p>
                  </div>
                  <div
                    v-if="matchmakingDetail.companyWebsite"
                    class="grid__cell col4-of-12--large-up mb-sm"
                  >
                    <p class="theme-text-dark fw-semibold fs-sm mb-xs">
                      Contact website:
                    </p>
                    <p class="fs-sm theme-text-medium">
                      {{ matchmakingDetail.companyWebsite }}
                    </p>
                  </div>
                  <div
                    class="grid__cell col4-of-12--large-up mb-sm"
                    v-if="matchmakingDetail.phone"
                  >
                    <p class="theme-text-dark fw-semibold fs-sm mb-xs">
                      Contact number:
                    </p>
                    <p class="fs-sm theme-text-medium">
                      {{ matchmakingDetail.phone }}
                    </p>
                  </div>
                  <div
                    class="grid__cell col4-of-12--large-up mb-sm"
                    v-if="matchmakingDetail.companyLocation"
                  >
                    <p class="theme-text-dark fw-semibold fs-sm mb-xs">
                      Contact location:
                    </p>
                    <p class="fs-sm theme-text-medium">
                      {{ matchmakingDetail.companyLocation }}
                    </p>
                  </div>

                  <div
                    v-for="(item, i) in services"
                    :key="i"
                    class="grid__cell col4-of-12--large-up mb-sm"
                  >
                    <p
                      class="f-capitalize theme-text-dark fw-semibold fs-sm mb-xs"
                    >
                      {{ item.filter_name }}:
                    </p>
                    <p class="fs-sm theme-text-medium">
                      {{ item.options | options }}
                    </p>
                  </div>
                  <div
                    v-if="matchmakingDetail.accountEmail"
                    class="grid__cell col4-of-12--large-up mb-sm"
                  >
                    <p
                      class="f-capitalize theme-text-dark fw-semibold fs-sm mb-xs"
                    >
                      Zapier Account Email:
                    </p>
                    <p class="fs-sm theme-text-medium">
                      {{ matchmakingDetail.accountEmail }}
                    </p>
                  </div>
                  <div class="grid__cell" v-if="matchmakingDetail.comments">
                    <p
                      class="f-capitalize theme-text-dark fw-semibold fs-sm mb-xs"
                    >
                      comments:
                    </p>
                    <p class="fs-sm theme-text-medium">
                      {{ matchmakingDetail.comments }}
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </Card>
      </template>
    </div>
    <transition name="fade">
      <Modal
        v-if="discardModalOpen"
        :dark="true"
        :old="false"
        :newButtons="true"
        :modalShowing="true"
        title="Discard changes?"
        description="Are you sure you want to discard all the changes?"
        @close-modal="discardModalOpen = false"
        primaryText="Discard changes"
        secondaryText="Cancel"
        @primary-click="discardChanges"
        @secondary-click="discardModalOpen = false"
      />
    </transition>
  </div>
</template>

<script>
import { formatDate } from '@/utils/date';
import Card from '@/components/DesignSystem/Card';
import SectionHeading from '@/components/DesignSystem/SectionHeading';
import Select from '@/components/DesignSystem/Inputs/Select';
import HeaderBar from '@/components/DesignSystem/HeaderBar';
import Modal from '@/components/DesignSystem/Modal';
import Logo from '@/components/SpinningLogo';
import BackButton from '@/components/BackButton';
import { apiService } from '@/utils/api/index';
import { createNamespacedHelpers } from 'vuex';
const { mapGetters, mapActions } = createNamespacedHelpers(
  'matchmakingRequests/detail'
);

export default {
  name: 'MatchmakingDetail',
  components: {
    Card,
    SectionHeading,
    Select,
    HeaderBar,
    Logo,
    Modal,
    BackButton,
  },
  data() {
    return {
      partnerId: null,
      showHeaderBar: false,
      partners: [],
      selectedPartnerValue: '',
      selectedStatusValue: '',
      discardModalOpen: false,
      saveKey: 1,
    };
  },
  mounted() {
    this.fetchMatchmakingDetail({ id: this.$route.params.id }).then(() => {
      if (this.matchmakingDetail.isIntegrationDir) {
        if (!this.integrationPartners.length) {
          this.$store.commit('matchmakingRequests/detail/setLoading', true);
          this.fetchIntegrationPartners().then(data => {
            this.partners = data.sort((a, b) => a.name.localeCompare(b.name));
            this.$store.commit('matchmakingRequests/detail/setLoading', false);
          });
        } else {
          this.partners = this.integrationPartners.sort((a, b) =>
            a.name.localeCompare(b.name)
          );
        }
      } else {
        if (!this.agencyPartners.length) {
          this.$store.commit('matchmakingRequests/detail/setLoading', true);
          this.fetchAgencyPartners().then(data => {
            this.partners = data.sort((a, b) => a.name.localeCompare(b.name));
            this.$store.commit('matchmakingRequests/detail/setLoading', false);
          });
        } else {
          this.partners = this.agencyPartners.sort((a, b) =>
            a.name.localeCompare(b.name)
          );
        }
      }
      this.selectedStatusValue = this.matchmakingDetail.status;
    });
  },
  computed: {
    ...mapGetters([
      'loading',
      'matchmakingDetail',
      'agencyPartners',
      'integrationPartners',
    ]),
    name() {
      return (
        this.matchmakingDetail.firstName + ' ' + this.matchmakingDetail.lastName
      );
    },
    services() {
      if (typeof this.matchmakingDetail.services !== 'string') return [];
      return JSON.parse(this.matchmakingDetail.services);
    },
    selectedPartner() {
      if (this.isDisabled) {
        if (this.matchmakingDetail.isIntegrationDir) {
          return this.matchmakingDetail.techPartnerAssigned;
        } else {
          return this.matchmakingDetail.partnerAssigned;
        }
      } else {
        return this.selectedPartnerValue;
      }
    },
    isDisabled() {
      if (this.matchmakingDetail.isIntegrationDir) {
        return (
          typeof this.matchmakingDetail.techPartnerAssigned !== 'undefined' &&
          this.matchmakingDetail.techPartnerAssigned !== null
        );
      } else {
        return (
          typeof this.matchmakingDetail.partnerAssigned !== 'undefined' &&
          this.matchmakingDetail.partnerAssigned !== null
        );
      }
    },
  },
  filters: {
    options: function(value) {
      if (typeof value === 'string') {
        return value;
      }

      let string = '';
      value.forEach(item => {
        string += `${item}, `;
      });
      return string.slice(0, -2);
    },
  },
  methods: {
    ...mapActions([
      'fetchMatchmakingDetail',
      'fetchIntegrationPartners',
      'fetchAgencyPartners',
    ]),
    showDate(date) {
      if (date) {
        return formatDate(new Date(String(date)));
      }
      return '-';
    },
    updateStatus(e) {
      this.selectedStatusValue = e.value;
      this.showHeaderBar = true;
    },
    updatePartner(data) {
      this.selectedPartnerValue = data.value;
      this.showHeaderBar = true;
    },
    discardChanges() {
      if (this.isDisabled) {
        if (this.matchmakingDetail.isIntegrationDir) {
          this.selectedPartnerValue = this.matchmakingDetail.techPartnerAssigned;
        } else {
          this.selectedPartnerValue = this.matchmakingDetail.partnerAssigned;
        }
      } else {
        this.updatePartner({
          name: 'Select an option',
          value: 'default',
        });
      }
      this.selectedStatusValue = this.matchmakingDetail.status;
      this.discardModalOpen = false;
      this.showHeaderBar = false;
      this.saveKey += 1;
    },
    async saveMatchmakingRequest() {
      let data = this.matchmakingDetail;
      if (this.selectedPartnerValue) {
        if (this.matchmakingDetail.isIntegrationDir) {
          data.techPartnerAssigned = this.selectedPartnerValue;
        } else {
          data.partnerAssigned = this.selectedPartnerValue;
        }
      }
      if (this.selectedStatusValue) {
        data.status = this.selectedStatusValue;
      }
      this.$store.commit(
        'matchmakingRequests/detail/setMatchmakingDetail',
        data
      );

      this.$store.commit('resetSaveProgress', null, { root: true });
      this.$store.commit('setSaveTotalItems', 1, { root: true });
      this.$store.commit('setSaving', 'saving', { root: true });

      const res = await apiService.patch(
        `/dashboard_vendor/matchmaking_requests/${this.$route.params.id}/`,
        this.matchmakingDetail
      );
      if (res.status < 400) {
        this.$store.commit('addSaveProgress', null, { root: true });
        this.$store.commit('setSaving', 'idle', { root: true });
        this.showHeaderBar = false;
        this.$store.dispatch('showUserMessage', {
          success: true,
          title: 'Success!',
          message: 'Your changes have been made.',
        });
      } else {
        this.$store.commit('addSaveProgress', null, { root: true });
        this.$store.commit('setSaving', 'idle', { root: true });
        this.showHeaderBar = false;
        this.$store.dispatch('showUserMessage', {
          success: false,
          title: 'Error',
          message: res.responseText,
        });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.grid .grid__cell {
  margin-bottom: 1.25em;

  .f-capitalize {
    margin-bottom: 0.33em;
  }
}
</style>
